<template>
  <b-badge
    :variant="variant"
    class="active-badge"
  >
    {{ variantText }}
  </b-badge>
</template>

<script>
export default {
  name: 'ActiveBadge',
  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    variant() {
      return this.active ? 'success' : 'danger';
    },
    variantText() {
      return this.active ? 'Active' : 'Inactive';
    },
  },
};
</script>
